import TranslationUtils from '@gik/core/utils/TranslationUtils';

const blockName = 'redemption-modal';

const translations = {
  headerEntry: 'Ways to use',
  headerGiftValue: 'Gift Value',
  headerVisaCard: 'Visa Card Type',
  headerPhysicalVisaCard: 'Shipping Address',
  headerZelle: 'Zelle Account',
  headerReview: 'Review & Redeem',
  headerChooseBrand: 'Choose Brand',
  linkToCreditCardHelperText: 'Use your own card to pay instead of keeping track of a gift card, and get paid back immediately! Your gift can never be lost or stolen.',
  linkToCreditCardBtn: 'Link to debit or credit card',
  useeGiftHelperText: 'Receive a standard eGift code in your Wallet to be scanned or entered at checkout.',
  useeGiftBtn: 'Use as an eGift',
  seeHowItWorksLink: 'See how it works',
  useAtAnotherMerchantBtn: 'Use at another merchant',
  changeTheBrandBtn: 'Change the brand',
  changeTheBrandHelperText: 'Swap your gift for one of 200+ brands',
  swapForVisaCardBtn: 'Swap for a Visa card',
  swapForVisaCardHelperText: 'Digital or physical. Use wherever Visa is accepted (restrictions may apply)',
  title: 'How would you like to use your <bold>{{service}}</bold> gift?',
  getDigitalVisaCardBtn: 'Get a Digital Visa card',
  getDigitalVisaCardHelperText: 'Immediately available. For online and phone purchases only.',
  getPhysicalVisaCardBtn: 'Get a Physical Visa card',
  getPhysicalVisaCardHelperText: 'Sent by mail within 2-7 business days. Shipping from $2.',
  useAtStoreBtn: 'Use at a store',
  useAtStoreHelperText: 'Swap your gift for one of 200+ brands.',
  useAsVisaBtn: 'Use as a Visa card',
  useAsVisaHelperText: 'Digital or physical. Use wherever Visa is accepted (restrictions may apply)',
  sendViaZelleBtn: 'Send funds via Zelle',
  sendViaZelleHelperText: 'Send to your bank account via Zelle. $4 processing fee.',
  toLinkCardBtn: 'To Link Card',
  toGiftValuedBtn: 'To Gift Value',
  toReviewBtn: 'To Review',
  toAddressBtn: 'To Address',
  toAccountBtn: 'To Account',
  toRedeemAndReviewBtn: 'Review & Redeem',
  visaCardTitle: 'Select your preferred Visa card:',
  digitalVisaCardRadioTitle: 'Digital Visa',
  digitalVisaCardDescription: 'Immediately available in your Wallet. For online and phone purchases only',
  physicalVisaCardRadioTitle: 'Physical Visa',
  physicalVisaCardDescription: 'Sent by mail within 2-7 business days.',
  physicalVisaCardHelperText: 'Shipping from $2',
  physicalVisaStepTitle: 'Where can we send your Visa card?',
  zelleStepTitle: 'Your Zelle account details',
  firstName: 'First Name',
  lastName: 'Last Name',
  streetAddress: 'Street Address',
  city: 'City',
  state: 'State',
  zip: 'Zip Code',
  usAddressOnlyInfo: 'US Addresses Only',
  rememberMyZelleAccount: 'Remember my Zelle Account',
  email: 'Email',
  mobileNumber: 'Mobile Number',
};

export default {
  [blockName]: translations,
};

export const translationKeys: typeof translations = TranslationUtils.mapKeys(blockName, translations);
